var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.waitingRoomActive)?_c('section',[_c('v-table',{ref:"table",attrs:{"url":"/api/v1/dialog/waiting-room-dialogs","attributes":[
      {
        attribute: 'customer',
        name: 'Mitglied',
        type: _vm.customerCell,
        sortable: false
      },
      {
        attribute: 'fake',
        name: 'Fake',
        type: _vm.customerCell,
        sortable: false
      },
      {
        attribute: 'dialog_id',
        name: 'Dialog',
        type: 'DialogInfoCell',
        sortable: false
      },
      {
        attribute: 'waitingroom_user',
        name: 'Hinzugefügt von',
        type: 'UserNoEmailCell',
        sortable: false
      },
      {
        attribute: 'updated_at',
        name: 'Dauer im Wartezimmer',
        type: 'TimeCounterCell',
        sortable: false
      },
      {
        attribute: 'last_message_at',
        name: 'Letzte Mitgliedsnachricht vor',
        type: 'TimeCounterCell',
        sortable: false
      },
      {
        name: 'Aktionen',
        type: 'WaitingroomDialogActionCell',
        sortable: false
      }
    ]},on:{"table-fetched":_vm.tableFetched}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Dialoge im Wartezimmer\n    ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }